import type {
  IForgotPasswordRequest,
  IForgotPasswordResponse,
  ILoginRequest,
  ILoginResponse,
  ILogoutResponse,
  IRefreshTokenRequest,
  IRefreshTokenResponse,
  IResetPasswordRequest,
  IResetPasswordResponse,
  ISignupPasswordRequest,
  ISignupPasswordResponse,
  ISignupRequest,
  ISignupResponse,
} from "./types";
import type { R } from "../types";
import { axiosInstance } from "../../axios-instance";
import qs from "qs";

interface IAuthService {
  login: (p: ILoginRequest) => R<ILoginResponse>;
  signup: (p: ISignupRequest) => R<ISignupResponse>;
  signupPassword: (p: ISignupPasswordRequest) => R<ISignupPasswordResponse>;
  forgotPassword: (p: IForgotPasswordRequest) => R<IForgotPasswordResponse>;
  resetPassword: (p: IResetPasswordRequest) => R<IResetPasswordResponse>;
  refreshToken: (p: IRefreshTokenRequest) => R<IRefreshTokenResponse>;
}

export class AuthService implements IAuthService {
  async login(p: ILoginRequest): R<ILoginResponse> {
    try {
      return axiosInstance.post("/api/auth/login", p);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async signup(p: ISignupRequest): R<ISignupResponse> {
    try {
      return axiosInstance.post("/api/auth/signup", p);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async signupPassword(p: ISignupPasswordRequest): R<ISignupPasswordResponse> {
    try {
      return axiosInstance.post("/api/auth/signupPassword", p);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async forgotPassword(p: IForgotPasswordRequest): R<IForgotPasswordResponse> {
    try {
      const params = qs.stringify(p);
      return axiosInstance.post(`/api/user/forgot-password?${params}`);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async resetPassword(p: IResetPasswordRequest): R<IResetPasswordResponse> {
    try {
      const params = qs.stringify(p);
      return axiosInstance.post(`/api/user/reset-password?${params}`);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async refreshToken(p: IRefreshTokenRequest): R<IRefreshTokenResponse> {
    try {
      if (p.refreshToken) {
        return axiosInstance.post("/api/auth/refreshToken", p);
      }

      return axiosInstance.post("/api/auth/refreshToken", {});
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async logout(): R<ILogoutResponse> {
    try {
      return axiosInstance.post("/api/auth/logout", {});
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
